import { createContext } from './utils';
import { AppStoreSnapshot } from '../types';

export interface WithAppStoreSnapshot {
    appStoreSnapshot: AppStoreSnapshot;
    refreshAppStoreSnapshot?: () => Promise<void>;
}

const {
    Consumer,
    Provider,
    withContext: withAppStoreSnapshot,
    Context,
} = createContext<WithAppStoreSnapshot>({
    appStoreSnapshot: {
        installableApps: [],
        maxAppsPerUser: 100,
        targetPlatformsByChannel: {},
        categories: [],
        ageRestrictions: [],
    },
    refreshAppStoreSnapshot: () => Promise.resolve(),
});

export { Consumer, Provider, withAppStoreSnapshot, Context };
